// 文档 https://developers.google.com/analytics/devguides/collection/ga4/reference/events?hl=zh-cn

/**
 * 等待 window.gtag 初始化
 * 最长等待 50 秒（可调整），每 100ms 检测一次
 */
function waitForGtag(timeout = 50000) {
  return new Promise((resolve, reject) => {
    const interval = 100;
    let elapsed = 0;

    const timer = setInterval(() => {
      if (typeof window.gtag === 'function') {
        clearInterval(timer);
        resolve(window.gtag);
      } else {
        elapsed += interval;
        if (elapsed >= timeout) {
          clearInterval(timer);
          reject(new Error('gtag not loaded within timeout'));
        }
      }
    }, interval);
  });
}

/**
 * 加入购物车事件记录
 * @param {*货币} currency 
 * @param {*价值} value 
 * @param {*商品信息数组} productGroup 
 */

export const gaAddToCart = async (currency, value, productGroup) => {
  try {
    await waitForGtag(); // 等待 gtag 可用
    var items = []
    productGroup.forEach(function (item) {
      items.push({
        item_id: item.productID,
        item_name: item.productName,
        quantity: item.quantity,
        price: item.price
      })
    })
    window.gtag("event", "add_to_cart", {
      currency: currency || "AUD",
      value: value,
      items: items
    });
  } catch (error) {
    console.log(error.message);
  }
}


/**
 * 
 * @param {*货币} currency 
 * @param {*交易的唯一标识符} transaction_id 
 * @param {*与事件相关的货币价值} value 
 * @param {优惠券} coupon 
 * @param {邮费} shipping 
 * @param {*税费} tax 
 * @param {*与事件相关的商品。} items 
 */
export const gaPurchase = async ({ currency, transaction_id, value, coupon, shipping, tax, items }) => {
  try {
    await waitForGtag(); // 等待 gtag 可用
    window.gtag("event", "purchase", {
      currency: currency || "AUD",
      transaction_id: transaction_id,
      value: value,
      coupon: coupon || "",
      shipping: shipping || "",
      tax: tax || "",
      items: items
    });
  } catch (error) {
    console.log(error.message);
  }
}

export const gaBeginCheckout = async ({ currency, value, items }) => {
  try {
    await waitForGtag(); // 等待 gtag 可用
    window.gtag("event", "begin_checkout", {
      currency: currency || "AUD",
      value: value,
      items: items
    })
  } catch (error) {
    console.log(error.message);
  }
}